










import { Vue, Component } from 'vue-property-decorator';
import ConfigurarPantallaServipag from './ConfigurarPantallaServipag.vue';

@Component({
  components: { ConfigurarPantallaServipag },
})
export default class MantenedorServipagPantalla extends Vue {}
